/**
 * Gets the color hex code for the analytics pie chart.
 * @function
 * @name getChartEntryColor
 * @kind function
 * @param {number} idx The index number.
 * @returns {string} A string with the color hex code.
 * @exports
 */
export function getChartEntryColor(idx: number): string {
  // Figma High Fidelity 2.0, node 79089:811961: the donut segments' own
  // fills (verified from each segment's raw SVG), not the legend swatch
  // dots next to them - those are a stale color set left over in the file
  // and don't match what the chart itself actually renders.
  const colors = [
    "#AFAFAE",
    "#496786",
    "#88651F",
    "#B62217",
    "#0F766E",
    "#746080",
  ];

  return colors.at(idx) || "";
}
